<app-content *ngIf='applicationInfo() as applicationInfo'>
  <app-breadcrumbs>
    <li>
      <a routerLink='/e-uslugi'>E-usługi</a>
    </li>
    <li>
      {{ applicationInfo?.name }}
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      {{ applicationInfo?.name }}
    </h2>
  </section>
  @if (applicationInfo.content; as content) {
    <div [innerHTML]='content'></div>
  }
  <br>
  <div class='d-flex justify-content-end'>
    @if (authed) {
      @if (completedData) {
        <a class='btn btn-primary' routerLink='skladanie-wniosku'>
          {{ applicationInfo?.url | applicationInfoActionName }}
        </a>
      } @else {
        <div class="d-block">
          <app-alert class="d-block" style="width: 85%" [closable]="false">
            Aby złożyć wniosek lub zgłoszenie, należy wcześniej zaakceptować regulamin oraz wyrazić zgodę na przetwarzanie danych
            osobowych (RODO) w sekcji:
            <a routerLink="/moje-dane"><strong>Moje dane.</strong></a>
          </app-alert>
        </div>
      }
    } @else {
      <a class='btn btn-primary' routerLink='/goto-login-gov'>
        Zaloguj się aby przejść do formularza
      </a>
    }
  </div>
</app-content>
